// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","396":"94e0538c","455":"6dd762c8"}[chunkId] + ".chunk.js";
};